import { render, staticRenderFns } from "./CuentasCobro.vue?vue&type=template&id=50eced1f"
import script from "./CuentasCobro.vue?vue&type=script&lang=js"
export * from "./CuentasCobro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports